import type { ReactNode } from 'react';

export type Tone = 'ok' | 'warn' | 'bad' | 'info' | 'neutral' | 'teal';

/**
 * Cặp nền / chữ của từng trạng thái — **lấy từ token**, không gõ mã màu.
 *
 * `teal` dành riêng cho "AdSense trực tiếp": phân biệt nó với "qua Network" mà
 * không phải mượn sắc đỏ (đỏ ở đây nghĩa là có vấn đề).
 */
const LOP: Record<Tone, string> = {
  ok: 'bg-ok-nen text-ok-chu',
  warn: 'bg-warn-nen text-warn-chu',
  bad: 'bg-bad-nen text-bad-chu',
  info: 'bg-info-nen text-info-chu',
  neutral: 'bg-neutral-nen text-neutral-chu',
  teal: 'bg-teal-nen text-teal-chu',
};

export interface StatusBadgeProps {
  tone?: Tone;
  children: ReactNode;
  /** Ẩn chấm màu khi chỉ cần nhãn. */
  cham?: boolean;
  className?: string;
}

export function StatusBadge({
  tone = 'neutral',
  children,
  cham = true,
  className = '',
}: StatusBadgeProps) {
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-chip px-2 py-0.5 text-phu font-medium whitespace-nowrap ${LOP[tone]} ${className}`}
    >
      {cham && (
        /* Chấm cùng màu chữ, mờ đi: thêm một mã màu thứ ba cho mỗi tone là ba
           chỗ phải sửa khi đổi bảng màu. */
        <span
          className="inline-block size-1.5 rounded-full bg-current opacity-70"
          aria-hidden="true"
        />
      )}
      {children}
    </span>
  );
}
